export const AuthReducer = (state, action) => {
  switch (action.type) {
    case "SETCOLOR": {
      return {
        ...state, 
        brandingColor: action.payload,
      };
    }
    case "SETPARTNER": {
      return {
        ...state, 
        partner: action.payload,
      };
    }
    case "PARTNERPACKAGE": {
      return {
        ...state, 
        partnerPackage: action.payload,
      };
    }
    case "ALLOWGUESTUPLOAD": {
      return {
        ...state, 
        allowGuestUpload: action.payload,
      };
    }
    case "AUTOAPPROVEUSER": {
      return {
        ...state, 
        autoApproveUser: action.payload,
      };
    }
    case "PARNTERNAME": {
      return {
        ...state, 
        partnerName: action.payload,
      };
    }
    case "LOADERDOMAIN": {
      return {
        ...state, 
        loaderDomain: action.payload,
      };
    }
    case "LOGIN": {
      return {
        ...state,
        currentUserSessionStorage: action.payload,
      };
    }
    case "LOGOUT": {
      return {
        ...state,
        currentUserSessionStorage: null,
      };
    }
    default:
      return state;
  }
};